import { httpClient } from '@/infra/protocols/http';
import { IScriptDTO } from '@/modules/scripts/dtos/script.dto';
import { IScript } from '@/modules/scripts/entities/script.entity';
import { ScriptMapper } from '@/modules/scripts/mappers/script.mapper';

export async function regenerateScript(
  params: RegenerateScriptService.Params,
  data: RegenerateScriptService.Payload,
): Promise<RegenerateScriptService.Response> {
  const response = await httpClient.put<IScriptDTO[]>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/roteiro/regerar`,
    data,
  );

  return response.map(ScriptMapper.toPresentation);
}

export namespace RegenerateScriptService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
  }

  export type Payload = {
    prompt: string;
  };

  export type Response = IScript[];
}
